const baseUrl = window.globalVars.url_ajax;
export async function save(identify,nationality,mother_name,date_of_birth,genre) {
    const resp = await fetch(baseUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
        },
        body: 'action=add_documments_user&identify='+identify+'&nationality='+nationality+'&mother_name='+mother_name+'&date_of_birth='+date_of_birth+'&genre='+genre+'&nonce='+window.globalVars.nonce,
        credentials: 'same-origin'
    });
    return await resp.json();
}
